import { Injectable } from '@angular/core';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';
import { IListing } from 'src/app/interfaces/listing';
import { IListingFilter } from 'src/app/interfaces/listing-filter';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

import { IAuditLog } from '../interfaces/audit-log';
import { ListingDataSource } from './listing-data-source';

@Injectable()
export class ListingApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(
    role: string,
    ListingFilter?: IListingFilter
  ): ListingDataSource {
    return new ListingDataSource(this, role, ListingFilter);
  }

  // public list(role: string, filter?: {}) {
  //   let endpoint = `${environment.listingAdminUrl}/${role}/listings`;
  //   const url = this.commonFunctionService.findApiUrl(role);
  //   endpoint = this.addFilterToEndpoint(endpoint, filter);

  //   return this.Api.get(endpoint, url)
  //     .then((Listings: IListing[]) => Listings)
  //     .catch((error) => this.Api.handleError(error));
  // }

  public listWithPageEvent(role, filter?: {}, PageEvent?: NgPageEvent) {
    let endpoint = `${role}/listings`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url)
      .then(async (ResponseBody: IResponseBody) => {
        if (ResponseBody.data?.url) {
          return await fetch(ResponseBody.data.url)
            .then(function (response) {
              return response.json();
            })
            .then((listings) => {
              return listings;
            });
        } else {
          return ResponseBody;
        }
      })
      .catch((error) => this.Api.handleError(error));
  }

  public read(role: string, id: number, filter?: {}) {
    // let endpoint = this.endpoint(role, {id});
    // endpoint = this.addFilterToEndpoint(endpoint, filter);
    // return this.Api.get(endpoint)
    //   .then((Listing: IListing) => Listing)
    //   .catch(error => this.Api.handleError(error));
  }

  public save(role: string, Listing: IListing, filter?: {}) {
    return Listing.id
      ? this.update(role, Listing, filter)
      : this.create(role, Listing, filter);
  }

  public delete(role: string, Listing: IListing) {
    const endpoint = `${role}/listing/${Listing.id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url)
      .then(() => this.Api.handleSuccess(Listing.title + ' deleted.'))
      .catch((error) => this.Api.handleError(error));
  }

  public enable(role: string, Listing: IListing, enabled: boolean) {
    const endpoint = `${role}/listings/id/${Listing.id}/status`;
    const url = this.commonFunctionService.findApiUrl(role);

    const statusText = enabled ? ' enabled.' : ' disabled.';
    return this.Api.put(endpoint, { enabled }, url)
      .then(() => this.Api.handleSuccess(Listing.title + statusText))
      .catch((error) => this.Api.handleError(error));
  }

  public duplicate(role: string, Listing: IListing) {
    let endpoint = `${role}/listing/duplicate`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, Listing, url)
      .then((id: number) => {
        this.Api.handleSuccess(Listing.title + ' duplicated.');
        return id;
      })
      .catch((error) => this.Api.handleError(error));
  }

  protected create(role: string, Listing: IListing, filter?: {}) {
    let endpoint = `${role}/listing`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.post(endpoint, Listing, url)
      .then((listingId: number) => {
        this.Api.handleSuccess(Listing.title + ' saved.');
        return listingId;
      })
      .catch((error) => this.Api.handleError(error));
  }

  protected update(role: string, Listing: IListing, filter?: {}) {
    let endpoint = `${role}/listing/product-id/${Listing.id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.put(endpoint, Listing, url)
      .then((listingId: number) => {
        this.Api.handleSuccess(Listing.title + ' saved.');
        return listingId;
      })
      .catch((error) => this.Api.handleError(error));
  }

  public readAuditLog(role: string, id: number) {
    const endpoint = `${role}/listing-id/${id}/audit-log`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url)
      .then((AuditLog: IAuditLog) => AuditLog)
      .catch((error) => this.Api.handleError(error));
  }
}
